import { render, staticRenderFns } from "./VetDocument.vue?vue&type=template&id=48f87dc2&"
import script from "./VetDocument.vue?vue&type=script&lang=js&"
export * from "./VetDocument.vue?vue&type=script&lang=js&"
import style0 from "./VetDocument.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports